import React from "react";

/**
 * Renders an array of section descriptors into JSX.
 * Section types: "p" (paragraph), "h" (h2 heading), "list" (ul), "table".
 */
export default function LegalContentRenderer({ sections }) {
  if (!sections) return null;
  return (
    <>
      {sections.map((s, i) => {
        if (s.type === "h") {
          return (
            <h2 key={i} className="font-display text-xl font-semibold text-slate-900">
              {s.text}
            </h2>
          );
        }
        if (s.type === "p") {
          return <p key={i} dangerouslySetInnerHTML={{ __html: s.html }} />;
        }
        if (s.type === "list") {
          return (
            <ul key={i}>
              {s.items.map((item, j) => (
                <li key={j} dangerouslySetInnerHTML={{ __html: item }} />
              ))}
            </ul>
          );
        }
        if (s.type === "table") {
          return (
            <table key={i} className="my-4 w-full border-collapse">
              <thead>
                <tr className="bg-slate-50">
                  {s.headers.map((h, j) => (
                    <th key={j} className="border border-slate-200 p-2 text-left text-sm font-semibold">
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {s.rows.map((row, ri) => (
                  <tr key={ri}>
                    {row.map((cell, ci) => (
                      <td key={ci} className="border border-slate-200 p-2 text-sm">
                        {ci === 0 ? <code>{cell}</code> : cell}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          );
        }
        return null;
      })}
    </>
  );
}
